import { getId, isMockMode, simulateDelay } from "../api";

export const getDefaultAvatar = () => {
	if (isMockMode()) {
		const testData = [
			{
				typeId: 0,
				typeName: "Product",
			},
			{
				typeId: 50,
				typeName: "Service",
			},
		];

		return simulateDelay(50, () => testData);
	}

	return getId(`users/getdefaultavatar`);
};
